<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit="login">
                  <h1>Đăng nhập</h1>
                  <p class="text-muted">Đăng nhập vào tài khoản của bạn</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Nhập email" autocomplete="username email" v-model="user.email" required />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Nhập mật khẩu" autocomplete="current-password" v-model="user.password" required />
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button type="submit" variant="primary" class="px-4">Đăng nhập</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      loading: false
    }
  },
  mounted() {
  },
  methods: {
    login(evt) {
      evt.preventDefault();
      if (!this.user.email) {
        this.$toasted.show('Vui lòng nhập email', {
          type: "error"
        });
      }
      if (!this.user.password) {
        this.$toasted.show('Vui lòng nhập mật khẩu', {
          type: "error",
          duration: 5000
        });
      }

      let {email, password} = this.user
      email = email.toLowerCase()
      this.$http.post(this.$configs.api + '/api/v4/cp/admin/login', {
        email,
        password,
      }).then(({data}) => {

        if (data && data.token) {
          localStorage.setItem("user", JSON.stringify(data));
          this.$cookies.set("user", JSON.stringify(data));
          localStorage.setItem("token", data.token);
          this.$cookies.set("token", data.token);
          this.$toasted.show('Đăng nhập thành công', {
            type: "success",
            duration: 2000
          });
          const username = data.email || 'NA';
          const email = data.email || 'NA';

          this.$gtag.event('user_login', {
            event_category: 'authentication',
            event_label: 'User logged in',
            user_name: username,
            user_email: email,
            user_id: data?._id || 'NA'
          });

          this.$router.push("/dashboard");
        } else {
          this.$toasted.show('Tài khoản không chính xác. Vui lòng liên hệ quản trị viên để được hướng dẫn', {
            type: "error",
            duration: 5000
          });
        }
      }).catch((err) => {
        if (err.response.data.message && err.response.data.message.data) {
          this.$toasted.error(err.response.data.message.data, {
            duration: 5000
          });
        } else if (typeof err.response.data.message === 'string') {
          this.$toasted.error(err.response.data.message, {
            duration: 5000
          });
        } else {
          this.$toasted.error("Đã có lỗi xảy ra", {
            duration: 5000
          });
        }


      })
    }
  }
}
</script>
